var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarTracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_1512",
    "data-name": "Raggruppa 1512",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 25,
    viewBox: "0 0 25.616 14.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3837",
    "data-name": "Tracciato 3837",
    d: "M1.46,4.931H.547A.476.476,0,0,0,0,5.461v3.3c0,.353.182.529.609.529H1.4c.426,0,.609-.176.609-.529v-3.3A.477.477,0,0,0,1.46,4.931Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3838",
    "data-name": "Tracciato 3838",
    d: "M19.649,9.991c-.07-.011-.121-.059-.121-.176a3.605,3.605,0,0,1,.121-.589.228.228,0,0,0-.182-.294.4.4,0,0,1-.3-.412c0-.236.121-.353.365-.412a.667.667,0,0,0,.183-.059c.005-.106.126-.642-.791-.882-.547-.117-3.407-.589-4.259-.706a.593.593,0,0,1-.365-.176c-.547-.647-1.095-1.295-1.642-2a3.668,3.668,0,0,0-2.007-1.177,54,54,0,0,0-6.752,0c-.482.116-.981.435-1.005.947s-.03,4.114-.09,5.7c0,.294-.124.284-.3.294s-.365.054-.365.294a6.641,6.641,0,0,0,.153,1.227c.054.131.346.358.759-.286A3.178,3.178,0,0,1,6.083,9.638,2.887,2.887,0,0,1,8.8,11.58c.061.117.121.236.3.236h4.221c.121,0,.173-.05.244-.177a3.149,3.149,0,0,1,2.92-2,3.234,3.234,0,0,1,3.1,1.883c.058-.152.3-.942.365-1.118C20.075,10.05,19.953,10.034,19.649,9.991Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3839",
    "data-name": "Tracciato 3839",
    d: "M5.9,10.185A2.409,2.409,0,1,0,5.9,15a2.409,2.409,0,1,0,0-4.815Zm0,3.48a1.074,1.074,0,1,1,1.109-1.073A1.093,1.093,0,0,1,5.9,13.666Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3840",
    "data-name": "Tracciato 3840",
    d: "M16.583,10.185a2.409,2.409,0,1,0,2.489,2.407A2.449,2.449,0,0,0,16.583,10.185Zm0,3.48a1.074,1.074,0,1,1,1.109-1.073A1.093,1.093,0,0,1,16.583,13.666Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3841",
    "data-name": "Tracciato 3841",
    d: "M17.707,0a.757.757,0,0,0-.292.09.787.787,0,0,0-.236.2.822.822,0,0,0-.145.278A.843.843,0,0,0,17,.884a.821.821,0,0,0,.279.549.771.771,0,0,0,.268.151.751.751,0,0,0,.3.033,6.293,6.293,0,0,1,6.211,6.461.824.824,0,0,0,.227.571.755.755,0,0,0,1.1,0,.824.824,0,0,0,.227-.571A7.916,7.916,0,0,0,17.852,0q-.036,0-.073,0C17.755,0,17.732,0,17.707,0Zm0,3.231a.771.771,0,0,0-.528.29A.834.834,0,0,0,17,4.115a.821.821,0,0,0,.279.549.759.759,0,0,0,.57.183,3.162,3.162,0,0,1,2.4.732,3.477,3.477,0,0,1,.7,2.5.825.825,0,0,0,.227.571.755.755,0,0,0,1.1,0,.824.824,0,0,0,.227-.571,5.074,5.074,0,0,0-1.165-3.634,4.625,4.625,0,0,0-3.494-1.211q-.036,0-.073,0C17.755,3.23,17.732,3.23,17.707,3.232Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarTracking);
export default __webpack_public_path__ + "static/media/CarTracking.ac00cf120eeda9a4019e69c45c8e9037.svg";
export { ForwardRef as ReactComponent };